<template lang="pug">
.edit
  header.edit__hero
    .edit__hero-grid
    .edit__hero-glow.edit__hero-glow--blue
    .edit__hero-glow.edit__hero-glow--red
    .edit__hero-inner
      button.edit__back(@click="voltar")
        FontAwesomeIcon(:icon="['fas','arrow-left']")
        span Evento
      p.edit__eyebrow
        span.edit__eyebrow-pip
        | Painel do organizador
      h1.edit__title Editar Evento
      p.edit__sub Atualize as informações da etapa, as arenas e as categorias que vão competir.

  .edit__wrap
    .edit__denied(v-if="!canManage")
      FontAwesomeIcon.edit__denied-ic(:icon="['fas','lock']")
      .edit__denied-text
        strong Acesso restrito
        span Você precisa ser admin do evento ou Organizador para editá-lo.

    .edit__denied(v-else-if="!currentEvent")
      FontAwesomeIcon.edit__denied-ic(:icon="['far','calendar']")
      .edit__denied-text
        strong Nenhum evento selecionado
        span Escolha um evento primeiro na tela de eventos.

    form.edit__card(v-else @submit.prevent="doSave")
      section.edit__section
        p.edit__legend
          span.edit__legend-num 01
          | Identificação

        label.field
          span.field__label Nome do evento *
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','trophy']")
            input.field__input(v-model="name" placeholder="Nome do evento")

        label.field
          span.field__label Detalhes / descrição
          .field__control.field__control--area
            FontAwesomeIcon.field__ic.field__ic--top(:icon="['fas','align-left']")
            textarea.field__input.field__textarea(v-model="description" placeholder="Descrição, regras, observações...")

        label.field
          span.field__label Banner / logo do evento
          .banner
            .banner__preview
              img(v-if="banner" :src="banner" alt="")
              FontAwesomeIcon(v-else :icon="['fas','image']")
            label.banner__btn
              FontAwesomeIcon(:icon="['fas','image']")
              | {{ banner ? 'Trocar imagem' : 'Adicionar imagem' }}
              input.banner__input(type="file" accept="image/*" @change="doSelectBanner")

        label.switch(:class="{ 'switch--on': isTest }")
          input.switch__input(type="checkbox" v-model="isTest")
          span.switch__track
            span.switch__thumb
          span.switch__text
            strong Evento de teste
            span Permite gerar e apagar chaves livremente, para simulações.

      section.edit__section
        p.edit__legend
          span.edit__legend-num 02
          | Quando e onde

        .edit__grid
          label.field
            span.field__label Data de início
            .field__control
              FontAwesomeIcon.field__ic(:icon="['far','calendar-alt']")
              input.field__input(type="date" v-model="startat")
          label.field
            span.field__label Data de término
            .field__control
              FontAwesomeIcon.field__ic(:icon="['far','calendar-check']")
              input.field__input(type="date" v-model="endat")

        label.field
          span.field__label Local / endereço
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','map-marker-alt']")
            input.field__input(v-model="address" placeholder="Ginásio, cidade, etc.")

        label.field
          span.field__label Quantidade de arenas
          .field__control
            FontAwesomeIcon.field__ic(:icon="['fas','vector-square']")
            input.field__input(type="number" min="1" max="20" v-model.number="arenas" placeholder="1")
          span.field__help Quantas arenas o evento usa. Com 1, as lutas são agendadas em sequência. Com 2 ou mais, salve o evento para escolher a arena de cada categoria.

        .edit__arenas(v-if="listaArenas.length")
          span.field__label Nomes das arenas
          input.field__input(
            v-for="a in listaArenas"
            :key="a.id"
            v-model="a.name"
            maxlength="50"
            :aria-label="'Nome da arena ' + a.id"
          )
          span.field__help As arenas são compartilhadas: o nome novo também aparece nos outros eventos que usam a mesma arena.

        label.edit__revezar(v-if="arenas > 1")
          input(type="checkbox" v-model="umaPorVez")
          span As arenas se revezam: nunca há duas lutas ao mesmo tempo

        //- ----- Categorias -----
        .edit__cats-block
          span.field__label Categorias
          p.field__help Marque as categorias do evento e informe, em cada uma, o máximo de robôs (mínimo 2) e o tempo do round em minutos. Categoria com robô inscrito ou luta gerada não pode ser removida.
          .edit__cats
            label.cat(
              v-for="c in takeCategories"
              :key="c.value"
              :class="{ 'cat--on': selectedCategories.includes(c.value), 'cat--locked': isCategoryLocked(c.value) }"
              :title="isCategoryLocked(c.value) ? 'Já tem robô inscrito ou luta gerada nesta categoria' : ''"
            )
              input.cat__check(
                type="checkbox"
                :value="c.value"
                :disabled="isCategoryLocked(c.value)"
                v-model="selectedCategories"
              )
              span.cat__box
                FontAwesomeIcon(:icon="['fas','check']")
              span.cat__name {{ c.text }}
              FontAwesomeIcon.cat__lock(v-if="isCategoryLocked(c.value)" :icon="['fas','lock']")
              span.cat__max(v-if="selectedCategories.includes(c.value)")
                FontAwesomeIcon.cat__max-ic(:icon="['fas','robot']")
                input.cat__max-input(
                  type="number"
                  min="2"
                  v-model.number="maxRobots[c.value]"
                  placeholder="Máx."
                  @click.prevent.stop
                )
              span.cat__max(v-if="selectedCategories.includes(c.value)" title="Tempo do round, em minutos")
                FontAwesomeIcon.cat__max-ic(:icon="['fas','stopwatch']")
                input.cat__max-input(
                  type="number"
                  min="0.5"
                  max="30"
                  step="0.5"
                  v-model.number="roundMinutos[c.value]"
                  placeholder="2"
                  :aria-label="'Tempo do round de ' + c.text + ', em minutos'"
                  @click.prevent.stop
                )
                span.cat__max-un min
              span.cat__max(v-if="selectedCategories.includes(c.value) && listaArenas.length > 1" title="Arena desta categoria")
                FontAwesomeIcon.cat__max-ic(:icon="['fas','vector-square']")
                select.cat__arena(
                  v-model.number="arenaCategoria[c.value]"
                  :aria-label="'Arena de ' + c.text"
                  @click.prevent.stop
                )
                  option(:value="0") A definir
                  option(v-for="a in listaArenas" :key="a.id" :value="a.id") {{ a.name }}
          .cat-nova
            input(type="text" maxlength="50" v-model="novaCategoria" placeholder="Nova categoria, ex.: Featherweight" @keydown.enter.prevent="doCriarCategoria")
            button(type="button" @click="doCriarCategoria") Criar categoria
          p.cat-nova-err(v-if="categoriaErro") {{ categoriaErro }}

      transition(name="fade")
        p.edit__alert.edit__alert--error(v-if="error")
          FontAwesomeIcon(:icon="['fas','exclamation-circle']")
          | {{ error }}
      transition(name="fade")
        p.edit__alert.edit__alert--ok(v-if="success")
          FontAwesomeIcon(:icon="['fas','check-circle']")
          | Evento atualizado! Redirecionando...

      button.edit__submit(type="submit")
        span Salvar alterações
        FontAwesomeIcon.edit__submit-ic(:icon="['fas','arrow-right']")

  //- ===== Zona de perigo: excluir evento (só Administrador) =====
  .edit__danger(v-if="isAdmin")
    .edit__danger-head
      FontAwesomeIcon.edit__danger-ic(:icon="['fas','exclamation-triangle']")
      div
        h3.edit__danger-title Excluir evento
        p.edit__danger-text
          | Apaga o evento e tudo ligado a ele: inscrições, inspeções, grupos, lutas e permissões. Robôs, equipes e usuários são preservados. #[strong Não tem volta.]
        p.edit__danger-text
          | Eventos com lutas já realizadas #[strong não podem ser excluídos] — a competição fica protegida assim que começa.
    button.edit__danger-btn(v-if="!confirmingDelete" type="button" @click="confirmingDelete = true")
      FontAwesomeIcon(:icon="['fas','trash']")
      span Excluir evento
    .edit__danger-confirm(v-else)
      label.edit__danger-label
        | Para confirmar, digite o nome do evento: #[strong {{ currentEvent ? currentEvent.name : '' }}]
      input.edit__danger-input(v-model="deleteConfirm" placeholder="Nome exato do evento")
      p.edit__alert.edit__alert--error(v-if="deleteError")
        FontAwesomeIcon(:icon="['fas','exclamation-circle']")
        | {{ deleteError }}
      .edit__danger-actions
        button.edit__danger-btn(type="button" :disabled="!deleteMatches" @click="doDelete")
          FontAwesomeIcon(:icon="['fas','trash']")
          span Excluir definitivamente
        button.edit__danger-cancel(type="button" @click="doCancelDelete") Cancelar
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { downscaleImage } from '@/utils/image'

export default {
  name: 'EditarEvento',
  data: () => ({
    name: '',
    description: '',
    address: '',
    arenas: 1,
    selectedCategories: [],
    maxRobots: {},
    roundMinutos: {},
    arenaCategoria: {},
    listaArenas: [],
    umaPorVez: false,
    novaCategoria: '',
    categoriaErro: '',
    categoriasEmUso: [],
    isTest: false,
    startat: '',
    endat: '',
    banner: '',
    bannerChanged: false,
    error: '',
    success: false,
    confirmingDelete: false,
    deleteConfirm: '',
    deleteError: ''
  }),
  created () {
    this.setCategories()
    this.setEvents().then(() => this.prefill())
  },
  computed: {
    ...mapGetters('users', ['getUser']),
    ...mapGetters('events', ['getCurrentEvent', 'getCurrentEventId', 'getEventSummary']),
    ...mapGetters('categories', ['getCategories']),
    takeCategories () {
      return [...this.getCategories].map(c => ({ text: c.name, value: c.id }))
    },
    currentEvent () {
      return this.getCurrentEvent
    },
    canManage () {
      const roles = this.getUser.roles
      return Array.isArray(roles) && (roles.includes(1) || roles.includes(6))
    },
    // Excluir é só do Administrador (papel 1) — nem Organizador pode. Mesma regra
    // do backend (delete_event).
    isAdmin () {
      const roles = this.getUser.roles
      return Array.isArray(roles) && roles.includes(1)
    },
    deleteMatches () {
      const nome = (this.currentEvent && this.currentEvent.name) || ''
      return !!nome && this.deleteConfirm.trim() === nome.trim()
    }
  },
  methods: {
    ...mapActions('events', ['setEvents', 'setUpdateEvent', 'setEventImage', 'fetchEventImage', 'setDeleteEvent', 'setEventSummary', 'fetchEventArenas', 'setArenaName']),
    ...mapActions('categories', ['setCategories', 'setCreateCategory']),
    // Categoria que ainda não existe no sistema (Hobbyweight, Featherweight...).
    doCriarCategoria () {
      const nome = (this.novaCategoria || '').trim()
      this.categoriaErro = ''
      if (!nome) {
        this.categoriaErro = 'Informe o nome da categoria.'
        return
      }
      this.setCreateCategory(nome).then((res) => {
        if (!res || !res.id) {
          this.categoriaErro = 'Não foi possível criar a categoria (verifique a permissão).'
          return
        }
        this.novaCategoria = ''
        if (!this.selectedCategories.includes(res.id)) this.selectedCategories.push(res.id)
        if (this.maxRobots[res.id] === undefined) this.$set(this.maxRobots, res.id, 8)
      })
    },
    doCancelDelete () {
      this.confirmingDelete = false
      this.deleteConfirm = ''
      this.deleteError = ''
    },
    doDelete () {
      this.deleteError = ''
      if (!this.deleteMatches) {
        this.deleteError = 'O nome digitado não confere.'
        return
      }
      this.setDeleteEvent({
        event_id: this.getCurrentEventId,
        confirm: this.deleteConfirm.trim()
      }).then(res => {
        if (!res || res.success === false) {
          this.deleteError = (res && res.error) || 'Não foi possível excluir o evento (verifique se você é Administrador deste evento).'
          return
        }
        // recarrega a lista (o evento atual sumiu) e volta para Eventos
        this.setEvents().then(() => this.$router.push('/Eventos'))
      })
    },
    // As datas do evento são "dia de calendário": o front envia "2026-08-15" e o
    // banco guarda 2026-08-15T00:00:00Z. Ler com getters LOCAIS (UTC-3) devolvia
    // o dia anterior, então a leitura é sempre em UTC.
    isoToDate (value) {
      if (!value) return ''
      const d = new Date(value)
      if (isNaN(d.getTime())) return ''
      const pad = n => String(n).padStart(2, '0')
      return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`
    },
    prefill () {
      const e = this.currentEvent
      if (!e) return
      this.name = e.name || ''
      this.description = e.description || ''
      this.address = e.address || ''
      this.isTest = !!e.is_test
      this.startat = this.isoToDate(e.startat)
      this.endat = this.isoToDate(e.endat)
      // Evento antigo pode não ter arena vinculada (arenas_count 0): mostra 1,
      // que é como o agendador já se comporta nesse caso.
      this.arenas = e.arenas_count > 0 ? e.arenas_count : 1
      this.umaPorVez = !!e.one_at_a_time
      this.fetchEventArenas(e.id).then(lista => { this.listaArenas = lista })
      this.fetchEventImage(e.id).then(img => { this.banner = img || '' })
      // Categorias atuais do evento, com max_robots e o que já está em uso.
      this.setEventSummary(e.id).then(() => {
        const resumo = this.getEventSummary || []
        this.selectedCategories = resumo.map(r => r.category_id)
        const maximos = {}
        for (const r of resumo) maximos[r.category_id] = r.max_robots || 2
        this.maxRobots = maximos
        const minutos = {}
        for (const r of resumo) minutos[r.category_id] = (r.round_seconds || 120) / 60
        this.roundMinutos = minutos
        const arenasDasCategorias = {}
        for (const r of resumo) arenasDasCategorias[r.category_id] = r.arena_id || 0
        this.arenaCategoria = arenasDasCategorias
        this.categoriasEmUso = resumo
          .filter(r => (r.robots || 0) > 0 || (r.fights_total || 0) > 0)
          .map(r => r.category_id)
      })
    },
    // Categoria com robô inscrito ou luta gerada: o backend recusa a remoção,
    // então a tela nem deixa desmarcar (e explica no title).
    isCategoryLocked (categoryId) {
      return this.categoriasEmUso.includes(categoryId)
    },
    doSelectBanner (ev) {
      const files = ev.target.files
      if (!files || !files.length) return
      const reader = new FileReader()
      reader.onload = () => {
        downscaleImage(reader.result).then(small => { this.banner = small; this.bannerChanged = true })
      }
      reader.readAsDataURL(files[0])
    },
    voltar () {
      this.$router.push('/EventoDetalhe')
    },
    doSave () {
      this.error = ''
      this.success = false
      if (!this.name.trim()) { this.error = 'Informe o nome do evento.'; return }
      if (this.startat && this.endat && this.endat < this.startat) {
        this.error = 'A data de término deve ser igual ou posterior à data de início.'
        return
      }
      if (!this.selectedCategories.length) {
        this.error = 'Marque ao menos uma categoria.'
        return
      }
      const semMaximo = this.selectedCategories.find(id => !(this.maxRobots[id] >= 2))
      if (semMaximo) {
        this.error = 'Informe o máximo de robôs (mínimo 2) de cada categoria marcada.'
        return
      }
      // Em branco vale o padrão de 2 minutos, o mesmo que o campo mostra.
      const minutosDe = id => (this.roundMinutos[id] === '' || this.roundMinutos[id] === undefined) ? 2 : this.roundMinutos[id]
      if (this.selectedCategories.some(id => !(minutosDe(id) >= 0.5 && minutosDe(id) <= 30))) {
        this.error = 'O tempo do round deve ficar entre 0,5 e 30 minutos.'
        return
      }
      const eventId = this.getCurrentEventId
      if (this.listaArenas.some(a => !(a.name || '').trim())) {
        this.error = 'Informe o nome de todas as arenas.'
        return
      }
      const nomesArenas = Promise.all(this.listaArenas.map(a =>
        this.setArenaName({ event_id: eventId, arena_id: a.id, name: a.name })))
      nomesArenas.then(() => this.setUpdateEvent({
        event_id: eventId,
        name: this.name.trim(),
        description: this.description,
        startat: this.startat || null,
        endat: this.endat || null,
        address: this.address,
        is_test: this.isTest,
        arenas: this.arenas,
        one_at_a_time: this.arenas > 1 ? this.umaPorVez : false,
        categories: this.selectedCategories.map(id => ({
          category_id: id,
          max_robots: this.maxRobots[id],
          round_seconds: Math.round(minutosDe(id) * 60),
          // Só com a lista carregada: sem ela o campo nem apareceu, e nil não mexe.
          ...(this.listaArenas.length > 1 ? { arena_id: this.arenaCategoria[id] || 0 } : {})
        }))
      })).then(response => {
        if (!response || response.success === false) {
          this.error = (response && response.error) || 'Não foi possível salvar (verifique a permissão).'
          return
        }
        // evento salvo. O banner é best-effort: conclui o fluxo mesmo se falhar.
        const finish = () => {
          this.success = true
          this.setEvents()
          setTimeout(() => this.$router.push('/EventoDetalhe'), 1200)
        }
        if (this.bannerChanged && this.banner) {
          this.setEventImage({ event_id: eventId, image: this.banner.split('base64,')[1] }).then(finish, finish)
        } else {
          finish()
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$blue-dark: #0F4FA8
$red: #DD3434
$red-dark: #B0231F
$green: #2E9E4F
$green-dark: #1F7C3C
$ink: #0B0E14
$paper: #FFFFFF
$muted: #5C6673
$line: rgba(11, 14, 20, 0.10)
$mist: #EEF1F6
$page: #F2F4F8

$display: 'Saira Condensed', 'Lato', sans-serif
$mono: 'Space Mono', 'Lato', monospace

.edit
  color: $ink
  background: $page
  min-height: calc(100vh - 64px)
  // respiro do rodapé aqui (padding), não como margin no último filho: margin
  // do filho "escapa" do container e deixava uma faixa branca do body embaixo
  padding-bottom: 64px
  font-family: Lato, sans-serif

  *
    box-sizing: border-box

  &__hero
    position: relative
    overflow: hidden
    isolation: isolate
    padding: 54px 0 60px
    background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
    color: #fff

  &__hero-grid
    position: absolute
    inset: 0
    background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
    background-size: 42px 42px
    mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    z-index: -2

  &__hero-glow
    position: absolute
    width: 360px
    height: 360px
    border-radius: 50%
    filter: blur(110px)
    opacity: 0.5
    z-index: -1
    &--blue
      background: $blue
      top: -150px
      left: -90px
    &--red
      background: $red
      bottom: -180px
      right: -80px

  &__hero-inner
    position: relative
    max-width: 760px
    margin: 0 auto
    padding: 0 24px

  &__back
    display: inline-flex
    align-items: center
    gap: 8px
    cursor: pointer
    background: rgba(255, 255, 255, 0.08)
    border: 1px solid rgba(255, 255, 255, 0.16)
    color: #fff
    border-radius: 8px
    padding: 7px 13px
    font-family: $mono
    font-size: 12px
    text-transform: uppercase
    letter-spacing: 0.06em
    margin-bottom: 18px
    transition: background .18s ease
    &:hover
      background: rgba(255, 255, 255, 0.16)

  &__eyebrow
    display: inline-flex
    align-items: center
    gap: 10px
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.22em
    font-size: 12px
    font-weight: 700
    color: rgba(255, 255, 255, 0.7)
    margin: 0 0 14px

  &__eyebrow-pip
    width: 8px
    height: 8px
    border-radius: 50%
    background: linear-gradient(135deg, #5AA0FF, $red)
    box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.18)

  &__title
    font-family: $display
    font-weight: 800
    text-transform: uppercase
    font-size: clamp(40px, 6vw, 66px)
    line-height: 0.94
    letter-spacing: -0.015em
    margin: 0

  &__sub
    font-size: 17px
    color: rgba(255, 255, 255, 0.74)
    margin: 16px 0 0
    max-width: 520px

  &__wrap
    max-width: 760px
    margin: 0 auto
    padding: 0 24px 72px

  &__card
    margin-top: -28px
    position: relative
    z-index: 1
    background: $paper
    border: 1px solid $line
    border-radius: 18px
    padding: 36px 34px
    box-shadow: 0 22px 50px rgba(11, 14, 20, 0.12)

  &__denied
    margin-top: -28px
    position: relative
    z-index: 1
    display: flex
    align-items: center
    gap: 18px
    padding: 26px 28px
    background: $paper
    border: 1px solid rgba(221, 52, 52, 0.22)
    border-left: 4px solid $red
    border-radius: 16px
    box-shadow: 0 22px 50px rgba(11, 14, 20, 0.10)
    &-ic
      font-size: 26px
      color: $red
      flex-shrink: 0
    &-text
      display: flex
      flex-direction: column
      gap: 4px
      strong
        font-family: $display
        text-transform: uppercase
        font-size: 20px
      span
        color: $muted
        font-size: 15px

  &__section
    padding: 0 0 28px
    margin-bottom: 28px
    border-bottom: 1px solid $line
    &:last-of-type
      border-bottom: none
      padding-bottom: 4px
      margin-bottom: 0

  &__legend
    display: flex
    align-items: center
    gap: 12px
    font-family: $display
    text-transform: uppercase
    letter-spacing: 0.01em
    font-size: 22px
    font-weight: 700
    margin: 0 0 18px

  &__legend-num
    font-family: $mono
    font-size: 12px
    font-weight: 700
    color: $blue
    background: rgba(40, 122, 237, 0.10)
    border-radius: 8px
    padding: 4px 9px

  &__grid
    display: grid
    grid-template-columns: 1fr 1fr
    gap: 16px

  &__alert
    display: flex
    align-items: center
    gap: 9px
    margin: 0 0 18px
    padding: 12px 14px
    border-radius: 10px
    font-size: 14px
    &--error
      color: $red-dark
      background: rgba(221, 52, 52, 0.08)
      border: 1px solid rgba(221, 52, 52, 0.22)
    &--ok
      color: $green-dark
      background: rgba(46, 158, 79, 0.10)
      border: 1px solid rgba(46, 158, 79, 0.25)

  &__submit
    display: inline-flex
    align-items: center
    justify-content: center
    gap: 10px
    height: 54px
    padding: 0 30px
    border: none
    border-radius: 10px
    cursor: pointer
    font-family: $display
    font-weight: 600
    text-transform: uppercase
    letter-spacing: 0.06em
    font-size: 17px
    color: #fff
    background: $blue
    box-shadow: 0 10px 24px rgba(40, 122, 237, 0.35)
    transition: transform .18s ease, box-shadow .18s ease, background .18s ease
    &:hover
      background: $blue-dark
      transform: translateY(-2px)
      box-shadow: 0 14px 30px rgba(40, 122, 237, 0.45)
    &-ic
      font-size: 13px
      transition: transform .2s ease
    &:hover &-ic
      transform: translateX(4px)

  // ---------- ZONA DE PERIGO (excluir evento) ----------
  &__danger
    max-width: 880px
    // o respiro do rodapé vem do padding-bottom de .edit (ver comentário lá)
    margin: 36px auto 0
    padding: 22px 24px
    border: 1px solid rgba(221, 52, 52, 0.4)
    border-radius: 14px
    background: rgba(221, 52, 52, 0.04)
    &-head
      display: flex
      align-items: flex-start
      gap: 14px
      margin-bottom: 16px
    &-ic
      font-size: 22px
      color: $red
      flex-shrink: 0
      margin-top: 2px
    &-title
      font-family: $display
      font-size: 20px
      font-weight: 700
      color: $red-dark
      margin: 0 0 4px
    &-text
      margin: 0
      font-size: 14px
      line-height: 1.5
      color: #6B4A4A
    &-btn
      display: inline-flex
      align-items: center
      gap: 10px
      height: 46px
      padding: 0 22px
      border: none
      border-radius: 10px
      cursor: pointer
      font-family: $display
      font-weight: 700
      text-transform: uppercase
      letter-spacing: .05em
      font-size: 15px
      color: #fff
      background: linear-gradient(140deg, $red, $red-dark)
      &:disabled
        opacity: .45
        cursor: not-allowed
      &:hover:not(:disabled)
        filter: brightness(1.06)
    &-confirm
      display: flex
      flex-direction: column
      gap: 10px
    &-label
      font-size: 14px
      color: #6B4A4A
    &-input
      max-width: 420px
      height: 46px
      padding: 0 14px
      border: 1px solid rgba(221, 52, 52, 0.45)
      border-radius: 10px
      font-family: inherit
      font-size: 15px
      &:focus
        outline: none
        border-color: $red
    &-actions
      display: flex
      align-items: center
      gap: 14px
      flex-wrap: wrap
    &-cancel
      background: none
      border: none
      cursor: pointer
      font-family: $display
      font-weight: 700
      font-size: 15px
      color: #7A8291
      &:hover
        color: $ink

  .field
    display: flex
    flex-direction: column
    margin-bottom: 16px
    &:last-child
      margin-bottom: 0
    &__label
      font-family: $mono
      text-transform: uppercase
      letter-spacing: 0.1em
      font-size: 11px
      font-weight: 700
      color: $muted
      margin-bottom: 8px
    &__help
      margin: 7px 0 0
      font-size: 12.5px
      line-height: 1.45
      color: $muted
    &__control
      position: relative
      display: flex
      align-items: center
      border: 1px solid $line
      border-radius: 10px
      background: #fff
      transition: border-color .18s ease, box-shadow .18s ease
      &:focus-within
        border-color: $blue
        box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.12)
      &--area
        align-items: flex-start
    &__ic
      position: absolute
      left: 16px
      font-size: 15px
      color: $muted
      pointer-events: none
      &--top
        top: 16px
    &__input
      flex: 1
      width: 100%
      box-sizing: border-box
      border: none
      background: none
      outline: none
      height: 52px
      padding: 0 16px 0 44px
      font-size: 15px
      color: $ink
      font-family: Lato, sans-serif
      &::placeholder
        color: rgba(92, 102, 115, 0.55)
    &__textarea
      height: auto
      min-height: 104px
      padding: 14px 16px 14px 44px
      resize: vertical
      line-height: 1.5

  .banner
    display: flex
    align-items: center
    gap: 16px
    &__preview
      display: grid
      place-items: center
      flex-shrink: 0
      width: 96px
      height: 60px
      border-radius: 10px
      overflow: hidden
      font-size: 22px
      color: #fff
      background: linear-gradient(135deg, $blue, $blue-dark 55%, $red)
      img
        width: 100%
        height: 100%
        object-fit: cover
    &__btn
      display: inline-flex
      align-items: center
      gap: 8px
      cursor: pointer
      font-family: $mono
      font-size: 12px
      font-weight: 700
      text-transform: uppercase
      letter-spacing: 0.04em
      color: $blue
      background: rgba(40, 122, 237, 0.08)
      border: 1px solid rgba(40, 122, 237, 0.28)
      border-radius: 8px
      padding: 10px 14px
      transition: background .18s ease
      &:hover
        background: rgba(40, 122, 237, 0.16)
    &__input
      display: none

  .switch
    display: flex
    align-items: center
    gap: 14px
    margin-top: 18px
    padding: 14px 16px
    border: 1px solid $line
    border-radius: 12px
    background: #fff
    cursor: pointer
    transition: border-color .18s ease, background .18s ease
    &--on
      border-color: rgba(40, 122, 237, 0.5)
      background: rgba(40, 122, 237, 0.05)
      .switch__track
        background: $blue
      .switch__thumb
        transform: translateX(20px)
    &__input
      position: absolute
      opacity: 0
      width: 0
      height: 0
    &__track
      position: relative
      flex-shrink: 0
      width: 46px
      height: 26px
      border-radius: 999px
      background: #C4C9D2
      transition: background .18s ease
    &__thumb
      position: absolute
      top: 3px
      left: 3px
      width: 20px
      height: 20px
      border-radius: 50%
      background: #fff
      box-shadow: 0 1px 3px rgba(11, 14, 20, 0.3)
      transition: transform .18s ease
    &__text
      display: flex
      flex-direction: column
      gap: 2px
      strong
        font-size: 15px
        font-weight: 700
        color: $ink
      span
        font-size: 13px
        color: $muted

  .edit__cats-block
    display: flex
    flex-direction: column
    margin-bottom: 16px

  .edit__cats
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 220px), 1fr))
    gap: 12px
    margin-top: 12px

  // ---------- categorias (mesmo cartão da tela de criação) ----------
  .cat-nova
    display: flex
    flex-wrap: wrap
    gap: 8px
    margin-top: 12px
    input
      flex: 1 1 200px
      min-height: 42px
      padding: 0 12px
      border: 1px solid rgba(11, 14, 20, 0.16)
      border-radius: 8px
      font-size: 14px
    button
      min-height: 42px
      padding: 0 16px
      border: 1px solid rgba(11, 14, 20, 0.16)
      border-radius: 8px
      background: #fff
      font-weight: 700
      cursor: pointer

  .cat-nova-err
    margin: 8px 0 0
    color: #B0231F
    font-size: 13px
    font-weight: 700

  .edit__arenas
    display: flex
    flex-direction: column
    gap: 8px

  .edit__revezar
    display: flex
    align-items: center
    gap: 10px
    font-size: 14px
    font-weight: 600
    cursor: pointer
    input
      width: 18px
      height: 18px

  .cat__arena
    max-width: 130px
    border: none
    background: none
    outline: none
    font-size: 14px
    font-weight: 600

  .cat
    display: flex
    flex-wrap: wrap
    align-items: center
    gap: 12px
    padding: 14px 16px
    border: 1px solid $line
    border-radius: 12px
    background: #fff
    cursor: pointer
    transition: border-color .18s ease, box-shadow .18s ease, background .18s ease
    &:hover
      border-color: rgba(40, 122, 237, 0.4)
    &--on
      border-color: $blue
      background: rgba(40, 122, 237, 0.05)
      box-shadow: 0 0 0 3px rgba(40, 122, 237, 0.10)
      .cat__box
        background: $blue
        border-color: $blue
        svg
          opacity: 1
          transform: scale(1)
    // categoria com robô inscrito ou luta: o backend recusa remover, a tela trava
    &--locked
      cursor: not-allowed
      &:hover
        border-color: $blue

    &__check
      position: absolute
      opacity: 0
      width: 0
      height: 0

    &__box
      display: grid
      place-items: center
      flex-shrink: 0
      width: 22px
      height: 22px
      border-radius: 6px
      border: 2px solid #C4C9D2
      color: #fff
      font-size: 11px
      transition: background .18s ease, border-color .18s ease, transform .18s ease
      svg
        opacity: 0
        transform: scale(.5)
        transition: opacity .15s ease, transform .15s ease

    &__name
      // reserva a maior parte da linha: os campos descem para a de baixo em vez de
      // espremer o nome da categoria
      flex: 1 1 60%
      min-width: 0
      font-weight: 600
      font-size: 15px

    &__lock
      flex-shrink: 0
      font-size: 11px
      color: $muted

    &__max
      display: inline-flex
      align-items: center
      gap: 6px
      flex-shrink: 0
      padding: 0 10px
      height: 36px
      border-radius: 8px
      background: $mist
      &-ic
        font-size: 12px
        color: $blue
      &-un
        font-size: 12px
        color: $muted
      &-input
        width: 46px
        border: none
        background: none
        outline: none
        font-family: $mono
        font-weight: 700
        font-size: 14px
        color: $ink
        text-align: center
        -moz-appearance: textfield
        appearance: textfield
        &::-webkit-outer-spin-button, &::-webkit-inner-spin-button
          -webkit-appearance: none
          margin: 0

  .fade-enter-active, .fade-leave-active
    transition: opacity .25s ease
  .fade-enter, .fade-leave-to
    opacity: 0

@media (max-width: 620px)
  .edit__hero
    padding: 38px 0 50px
  .edit__hero-inner
    padding: 0 18px
  .edit__wrap
    padding: 0 18px 56px
  .edit__card
    padding: 26px 20px
  .edit__grid
    grid-template-columns: 1fr
  .edit__submit
    width: 100%
</style>
